// extracted by mini-css-extract-plugin
export default {"banner":"style_banner__iVZlt","content":"style_content__KktN-","name":"style_name__ef+OZ","close":"style_close__1af3T","dark":"style_dark__ennnF"};